import {
  AccessTimeOutlined,
  CircleOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import { differenceInCalendarDays, parseISO, startOfDay } from 'date-fns';

import { graphql, type DocumentType } from '@/gql';

export const NEWS_TASKS_CARD_LIST_ITEM_DUE_DATE_ICON_FRAGMENT = graphql(`
  fragment newsTasksCardListItemDueDateIconFields on Assignment {
    _id
    dueDate
  }
`);

interface Props {
  assignment: DocumentType<
    typeof NEWS_TASKS_CARD_LIST_ITEM_DUE_DATE_ICON_FRAGMENT
  >;
}

export const NewsTasksCardListItemDueDateIcon = ({ assignment }: Props) => {
  const { dueDate } = assignment;

  const due = dueDate ? startOfDay(parseISO(dueDate)) : null;
  const today = startOfDay(new Date());

  const daysUntilDue = due ? differenceInCalendarDays(due, today) : null;

  const isOpenEnded = !dueDate;

  if (isOpenEnded) {
    return <CircleOutlined color="action" fontSize="inherit" />;
  }

  const isOverdue = daysUntilDue !== null && daysUntilDue < 0;

  if (isOverdue) {
    return <WarningAmberOutlined color="error" fontSize="inherit" />;
  }

  const isDueSoon =
    daysUntilDue !== null && daysUntilDue >= 0 && daysUntilDue <= 7;

  return (
    <AccessTimeOutlined
      color={isDueSoon ? 'warning' : 'action'}
      fontSize="inherit"
    />
  );
};
